// $(document).ready(function(){
//   $(document).on('click','.motion-reduce',function(){
//     var video_html = $(this).closest('.multicolumn-card__info').find('.videoclicked').html()
//     $('.popup_video_frame').html(video_html);
//     $('.overlay_frame').fadeIn();
//    });

//   $(document).on('click','.close_frame',function(){
//       $('.overlay_frame').fadeOut();
//    });
// });
$(".announcement-slider").slick({
  speed: 6000,
  autoplay: true,
  autoplaySpeed: 0,
  centerMode: true,
  cssEase: "linear",
  slidesToShow: 1,
  draggable: false,
  focusOnSelect: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  slidesToScroll: 1,
  variableWidth: true,
  infinite: true,
  initialSlide: 1,
  arrows: false,
  buttons: false,
});

$(document).ready(function () {
  setTimeout(function () {
    $(".video-section__poster").trigger("click");
  }, 2000);
});

$(".ts-slide-faq").slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  loop: true,
  arrow: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".ts-slide-testimonials").slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrow: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

jQuery(document).ready(function ($) {
  $(".slick.marquee").slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  });
   $(".faq-image-text-slider").slick({
dots: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrow: true
});
  $('.faq-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows:true,
    responsive: [
          {
                  breakpoint: 768,
                  settings: 'unslick'
          }
    ]
  });
    $('.faq-steps-slider').slick({
dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrow: true,
  adaptiveHeight: true,  
});
});

$(".marquee-list-------------").slick({
  speed: 100,
  autoplay: true,
  autoplaySpeed: 0,
  centerMode: true,
  cssEase: "linear",
  slidesToShow: 1,
  draggable: false,
  focusOnSelect: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  slidesToScroll: 1,
  variableWidth: true,
  infinite: true,
  initialSlide: 1,
  arrows: false,
  buttons: false,
});
// Show the first tab and hide the rest
$("#tabs-nav li:first-child").addClass("active");
$(".tab-content").hide();
$(".tab-content:first").show();

// Click function
$("#tabs-nav li").click(function () {
  $("#tabs-nav li").removeClass("active");
  $(this).addClass("active");
  $(".tab-content").hide();

  var activeTab = $(this).find("a").attr("href");
  $(activeTab).fadeIn();
  return false;
});
//  $(document).ready(function(){
// let o = null;
//     o = setInterval(function l() {
//         $(".ts-collection-ready-slider").length > 0 && (clearInterval(o), $('.ts-collection-product-slider').slick({
// 		  dots: true,
//   infinite: false,
//   slidesToShow: 2,
//   slidesToScroll: 2,
//   arrow: true,
//     centerMode: false,
//         }))
//     }, 5)
// });
// $(".ts-collection-ready-slider").slick({
//   infinite: true,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   centerPadding: '0',
//   centerMode: false,
//   arrow: true,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 2,
//         infinite: true,
//         dots: true,
//       },
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 2,
//       },
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//       },
//     },
//   ],
// });

$(function () {
  // Owl Carousel
  var owl = $(".ts-collection-ready-slider");
  owl.owlCarousel({
    items: 4,
    margin: 12,
    loop: true,
    nav: true,
    responsive: {
      0: {
        items: 1,
      },

      600: {
        items: 1.5,
      },
      768: {
        items: 2,
      },

      1024: {
        items: 4,
      },

      1366: {
        items: 4,
      },
    },
  });

  $(".owl-carousel.ts-product-accordians01").owlCarousel({
    loop: true,
    margin: 27,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
        margin: 30,
      },
      600: {
        items: 1,
        margin: 35,
      },
      1000: {
        items: 1,
      },
    },
  });

  $(".owl-carousel.ts-product-accordians02:not(.cur_eyes.he_schema .owl-carousel.ts-product-accordians02)").owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      600: {
        items: 1,
        nav: false,
      },
      1000: {
        items: 2,
        nav: true,
        loop: true,
      },
    },
  });
    $(".cur_eyes.he_schema .owl-carousel.ts-product-accordians02").owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      600: {
        items: 1,
        nav: false,
      },
      1000: {
        items: 1,
        nav: true,
        loop: true,
      },
    },
  });
});
// $(".collection-nav-slider").slick({
//   slidesToShow: 4,
//   slidesToScroll: 0,
//   asNavFor: ".ts-collection-ready-slider-slick",
//   dots: false,
//   autoplay: false,
//   centerMode: false,
//   focusOnSelect: true,
// });
//  $('.ts-collection-ready-slider-slick').slick({
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: true,
//   dots: false,
//   infinite: true,
//   asNavFor: '.collection-nav-slider'
// });
// $('.collection-nav-slider').slick({
//   infinite: true,
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   arrows: true,
//   asNavFor: '.ts-collection-ready-slider-slick',
//   dots: false,
//   centerMode: false,
//   focusOnSelect: true
// });
//  $('a[data-slide]').click(function(e) {
//    e.preventDefault();
//    var slideno = $(this).data('slide');
//    $('.collection-nav-slider').slick('slickGoTo', slideno - 1);
//  });

$(".slider-for").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: ".slider-nav",
});
$(".slider-nav").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: ".slider-for",
  dots: false,
  arrows: true,
  focusOnSelect: true,
  infinite: true,
  centerPadding: "10px",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        centerMode: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
      },
    },
  ],
});

$("a[data-slide]").click(function (e) {
  e.preventDefault();
  var slideno = $(this).data("slide");
  $(".slider-nav").slick("slickGoTo", slideno - 1);
  $("a[data-slide]").removeClass("active");
  $(this).addClass("active");
});

$(document).ready(function () {
  $(window).on("resize", function (e) {
    checkScreenSize();
  });

  checkScreenSize();

  function checkScreenSize() {
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 767) {
      $(".ts-before-after-slider").owlCarousel({
        loop: true,
        margin: 0,
        dots: false,
        nav: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            autoplay: true,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 0,
          },
        },
      });
    } else {
      $(".ts-before-after-slider").removeClass("owl-carousel");
    }
  }
});

$(document).ready(function () {
  $(".acc_btn").click(function () {
    $(".ts-Ingred-popup").addClass("opened");
  });
  $(".ts-popup-close").click(function () {
    $(".ts-Ingred-popup").removeClass("opened");
  });
});


var button = document.getElementsByClassName("but"),
  tabContent = document.getElementsByClassName("ts-pro-tab-content");
button[0].classList.add("active");
tabContent[0].style.display = "block";

function city(e, city) {
  var i;
  for (i = 0; i < button.length; i++) {
    tabContent[i].style.display = "none";
    button[i].classList.remove("active");
  }
  document.getElementById(city).style.display = "block";
  e.currentTarget.classList.add("active");
}


